'use strict';
angular.module('MW.InsDashboard.insightsBackendService', [
    'ngResource',
    'RegionService',
    'MW.InsDashboard.InsightsCacheConstants',
    'Configuration'
])
.factory('insightsBackendService', [
    '$resource',
    'RegionService',
    'InsightsCacheConstants',
    'VOLUME_SERVICE_VERSIONED_URL',
    'INSIGHTS_SERVICE_DOCUMENT_SERVICE_URL',
    function (
        $resource,
        RegionService,
        InsightsCacheConstants,
        VOLUME_SERVICE_VERSIONED_URL,
        INSIGHTS_SERVICE_DOCUMENT_SERVICE_URL) {
    var serviceObj = {};

    var volumeServices = $resource(VOLUME_SERVICE_VERSIONED_URL + '/:object', {cacheKey:InsightsCacheConstants.get('INS_VOLUME'), cacheCategory: 'SEARCH'}, {
        query: {
            method:'GET',
            params: {}
        }
    });
    serviceObj.volumeServices = volumeServices;

    var consolidatedService = $resource(VOLUME_SERVICE_VERSIONED_URL+'/consolidated',{cacheKey:InsightsCacheConstants.get('INS_CONSOLIDATED_REQUEST'), cacheCategory: 'SEARCH'}, {
        query:{
            method:'POST',
            params:{}
        }
    });
    serviceObj.consolidatedService = consolidatedService;

    var fairhairInsService = $resource(INSIGHTS_SERVICE_DOCUMENT_SERVICE_URL, {cacheKey:InsightsCacheConstants.get('INS_FAIRHAIR'), cacheCategory: 'SEARCH'}, {
        query: {
            method:'POST',
            params: {},
            transformResponse: function(data) {
                // First we have to parse it from json ourselves.
                data = angular.fromJson(data);

                // Now add our extra information to the document.
                data.documents = RegionService.regionalizeDocuments(data.documents);
                return data;
            }
        }
    });
    serviceObj.fairhairInsService = fairhairInsService;

    var getAcceptedParameters = function getAcceptedParameters(serviceName){
        var parameterList = {
            volumeServices :['searchTerm'],
            statisticServiceDateHistogram : ['searchTerm', 'granularity'],
            statisticDateAVEHistograms : ['searchTerm', 'granularity'],
            statisticServiceAvgDateHistogram : ['granularity' ,'searchTerm'],
            statisticServiceDateReachHistogram : ['granularity', 'searchTerm'],
            statisticService : ['granularity', 'searchTerm'],
            fairhairInsService : ['searchTerm'],
            countryHistograms : ['searchTerm'],
            sourceHistograms: ['searchTerm'],
            languageHistograms: ['searchTerm']
        };
        if(parameterList[serviceName]){
            return parameterList[serviceName];
        } else {
            return ([]);
        }
    };
    serviceObj.getAcceptedParameters = getAcceptedParameters;

    var validateParameter = function validateParameter(serviceName, parameterName){
        var pList = serviceObj.getAcceptedParameters(serviceName);
        return pList.indexOf(parameterName) > -1 ? true : false;
    };
    serviceObj.validateParameter = validateParameter;


    return serviceObj;
}]);
